import { FC } from 'react'
import { FormattedMessage } from 'react-intl'
import { generatePath, Link } from 'react-router'

import { Descriptions, Flex, Tabs, Typography } from 'antd'

import { Country } from '../../components/icon/Country'
import routes, { generateSlug } from '../../routes'

import { Description } from './Description'

const CardMeta: FC<{ data: MotoGP.StatsCategoriesEvent; name: string }> = ({ data, name }) => {
  const stat = data.find((it) => it.category.name === name)
  if (!stat?.event) return null
  return (
    <Flex gap={8} align={'center'}>
      <Typography.Text ellipsis code>
        {stat.event?.season}
      </Typography.Text>
      <Country height={16} country={stat.event?.country.iso} />
      <Typography.Text ellipsis>
        <Link to={generatePath(routes.track, { slug: generateSlug(stat.event.circuit.name) })}>
          {stat.event.circuit.name}
        </Link>
      </Typography.Text>
    </Flex>
  )
}

const Debut: FC<{ data: MotoGP.RiderStats }> = ({ data }) => {
  const categories: Record<string, MotoGP.StatsCategories> = data?.first_grand_prix
    .map((it) => it.category.name)
    .reduce((acc, it) => ({ ...acc, [it]: it }), {})
  if (!categories) return null

  return (
    <Description titleId={'rider.debut'}>
      <Tabs
        items={Object.keys(categories).map((it) => ({
          key: it,
          label: it,
          children: (
            <Descriptions
              size={'small'}
              layout={'vertical'}
              column={1}
              items={[
                {
                  label: <FormattedMessage id={'rider.stats.first-gran-prix'} />,
                  children: <CardMeta data={data.first_grand_prix} name={it} />,
                },
                {
                  label: <FormattedMessage id={'rider.stats.first-race-fastest-lap'} />,
                  children: <CardMeta data={data.first_race_fastest_lap} name={it} />,
                },
                {
                  label: <FormattedMessage id={'rider.stats.first-podium'} />,
                  children: <CardMeta data={data.first_podiums} name={it} />,
                },
                {
                  label: <FormattedMessage id={'rider.stats.first-pole'} />,
                  children: <CardMeta data={data.first_pole_positions} name={it} />,
                },
                {
                  label: <FormattedMessage id={'rider.stats.first-gran-prix-wins'} />,
                  children: <CardMeta data={data.first_grand_prix_victories} name={it} />,
                },
              ]}
            />
          ),
        }))}
      />
    </Description>
  )
}

export { Debut }
